import { render, staticRenderFns } from "./ShipmentEdit.pug?vue&type=template&id=f2c479f8&lang=pug&"
import script from "./ShipmentEdit.ts?vue&type=script&lang=ts&"
export * from "./ShipmentEdit.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports